import React from "react";
import "./App.css";
import Login from "./login";

function App() {
  return (
    <React.Fragment>
      <Login />
      {/*<Welcome />
      {/*<OptionCards />}
      <CardCounter />*/}
    </React.Fragment>
  );
}

export default App;
